import { render, staticRenderFns } from "./DatatableEntity.vue?vue&type=template&id=37e53818"
import script from "./DatatableEntity.vue?vue&type=script&lang=js"
export * from "./DatatableEntity.vue?vue&type=script&lang=js"
import style0 from "./DatatableEntity.vue?vue&type=style&index=0&id=37e53818&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports